import { useMemo } from 'react';
import { useLocation } from '@thd-olt-component-react/router';

export const useSearchParam = (name: string): null | string => {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    return params.get(name);
  }, [name, search]);
};
